// extracted by mini-css-extract-plugin
export default {"Spinner":"Spinner_Spinner__l2LgP","spin":"Spinner_spin__4wE35"};